export const ACTION = {
    GET_ABOUT_US_CONTENT: 'GET_ABOUT_US_CONTENT',
    GET_CODE_GOVERNANCE:'GET_CODE_GOVERNANCE',
    GET_BOARD_COMMITTEE:'GET_BOARD_COMMITTEE',
    GET_DISCLOSURES:'GET_DISCLOSURES',
    GET_DIVIDEND:'GET_DIVIDEND',
    GET_SHAREHOLDER_PRESENTATION:'GET_SHAREHOLDER_PRESENTATION',
    GET_FINANCIAL_RESULT:'GET_FINANCIAL_RESULT',
    GET_ANNUAL_REPORT:'GET_ANNUAL_REPORT',
    GET_LEADERSHIP_PROFILE:'GET_LEADERSHIP_PROFILE',
    GET_HDFC_MF_GLANCE_CONTENT:'GET_HDFC_MF_GLANCE_CONTENT',
    GET_ABOUT_US_MEDIA_CENTER:"GET_ABOUT_US_MEDIA_CENTER",
    GET_ABOUT_US_MEDIA_CENTER_VIDEO:"GET_ABOUT_US_MEDIA_CENTER_VIDEO",
    GET_CSR:"GET_CSR",
};